import AddressName from '../Components/AddressName';
import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return {
    addressRefrigerator: Object.values(state.addressRefrigerator)
  };
};

const connectedAddressRefrigerator = ({addressRefrigerator}) => (
  <div className="c-component c-address-refrigerator">
    <h2>Frozen addresses</h2>
    {addressRefrigerator.length ? (
      <ul className="c-address-refrigerator__list">
        {addressRefrigerator
          .filter(address => address.state)
          .map((freezeEvent) => (
            <li key={freezeEvent.address} className="c-address-refrigerator__list-item">
              <AddressName address={freezeEvent.address}/>
            </li>
          ))}
      </ul>
    ) : (
      <h4>No addresses have been frozen.</h4>
    )}
  </div>
);

const AddressRefrigerator = connect(mapStateToProps)(connectedAddressRefrigerator);

export default AddressRefrigerator;


// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/AddressRefrigerator.js